__turbopack_context__.v({
  "blok-big-title": "StoryblokImage-module__bNS3dG__blok-big-title",
  "blok-subtitle": "StoryblokImage-module__bNS3dG__blok-subtitle",
  "blok-title": "StoryblokImage-module__bNS3dG__blok-title",
  "image": "StoryblokImage-module__bNS3dG__image",
});
